<template>
  <div>
    <el-dialog
      name="CB推送文件查询"
      :visible="showPushFile"
      @close="closeCbDialog"
      @open="open"
      width="1200px"
      center
    >
      <div class="user-cbDialog-header">
        <div></div>
        <!-- <el-select v-model="cbDir" @change="cbHandle">
          <el-option
            v-for="item in cbOpts"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <div class="user-cbDialog-header-right">
          <!-- <el-select v-model="cbSearchType">
            <el-option key="name" label="文件名" value="name"></el-option>
          </el-select> -->
          <List-search
            ref="cbSearch"
            @listSearchEvn="cbSearchEvn"
            @clearSearch="clearCbSearch"
          />
          <button class="global-button-style" @click="getCB">更新</button>
        </div>
      </div>
      <div class="user-cbDialog-main" v-loading="cbLoading">
        <div class="global-body-wrap">
          <TableData
            ref="cbTable"
            :tableProps="cbProps"
            :tableData="limitData"
            :tableBtn="cbBtn"
            :currentPage="cbPage"
            :pageSize="cbLimit"
            :sortable="['notePointSize', 'status', 'updatedAt']"
            @tableSortOrder="cbTableSortOrder"
            @tableHandle="tableHandle"
            @filterEvn="filterEvn"
          />
        </div>
        <Pagination
          :pageSize="cbLimit"
          :total="cbDataLength"
          :currentPage="cbPage"
          @pageNum="cbPageNum"
        />
      </div>
    </el-dialog>

    <!-- <el-dialog :title="'详情'" :visible.sync="showPushFileDetails" width="30%">
      <div v-loading="cbDetailsLoading">
        <template v-if="currentCbItem">
          <div class="cbDetailsDialog-item">
            <p>当前页码：</p>
            <el-select
              v-if="currentCbItem.pageNameList"
              v-model="currentCbPageId"
            >
              <el-option
                v-for="(item, index) in currentCbItem.pageNameList.pageNameList"
                :key="item"
                :label="index + 1"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="cbDetailsDialog-item">
            <p>
              当前shapes：{{
                currentCbItem.shapeList.filter(
                  (item) => item.pageUniqueId === currentCbPageId
                ).length
              }}
            </p>
          </div>
          <div class="cbDetailsDialog-item">
            <p>
              当前点文件：{{
                currentCbItem.ossData.filter(
                  (item) => ~item.name.indexOf(currentCbPageId)
                ).length
              }}
            </p>
          </div>
        </template>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import ListSearch from '@/components/listSearch'
import Pagination from '@/components/pagination'
import TableData from '../tableData'
import syncUtils from '@/syncUtils'

export default {
  props: {
    showPushFile: {
      type: Boolean,
      default: false
    },
    userItem: {
      type: Object
    }
  },
  components: {
    ListSearch,
    TableData,
    Pagination
  },
  computed: {
    cbOpts() {
      return [
        {
          label: '全部',
          value: 'all'
        },
        {
          label: '推送手写模板(push_writeTemplate)',
          value: 'push_writeTemplate'
        },
        {
          label: '推送文件(digital_content)',
          value: 'digital_content'
        },
        {
          label: '通知刷新推送列表(refresh_push)',
          value: 'refresh_push'
        },
        {
          label: '通知刷订阅送列表(refresh_subsription)',
          value: 'refresh_subsription'
        },
        {
          label: '推送屏保(push_screensaver)',
          value: 'push_screensaver'
        },
        {
          label: '推送网页链接(webpage_content)',
          value: 'webpage_content'
        }
      ]
    },
    cbProps() {
      return [
        {
          prop: 'uniqueId',
          label: 'UniqueId'
        },
        // {
        //   prop: 'name',
        //   label: '文件名'
        // },
        // {
        //   prop: 'size',
        //   label: '大小'
        // },
        {
          prop: 'contentType',
          label: 'contentType'
        },

        {
          prop: 'msgType',
          label: 'msgType',
          width: 80
        },
        {
          prop: 'updatedAt',
          label: '更新时间'
        }
      ]
    },
    cbBtn() {
      return [
        // { label: '获取shape', type: 'checkShape' },
        // { label: '查看', type: 'checkDetails' }
      ]
    }
  },
  data() {
    return {
      filterType: [],
      sortType: 'updatedAt',
      orderType: 'descending',
      originData: [],
      cbData: [],
      cbPage: 1,
      cbLimit: 20,
      cbDataLength: 0,
      cbSearch: '',
      cbSearchType: 'uniqueId',
      cbLoading: false,
      currentCbItem: null,
      currentCbPageId: '',
      showPushFileDetails: false,
      cbDetailsLoading: false,
      limitData: [],
      sortData: [],
      searchData: []
    }
  },
  methods: {
    open() {
      this.getCB()
    },
    initCbData() {
      this.sortData = []
      this.limitData = []
      this.cbSearch = ''
      this.cbPage = 1
      this.$refs.cbTable ? this.$refs.cbTable.clearSort() : null
      this.$refs.cbSearch ? this.$refs.cbSearch.clearValue() : null
    },

    async getCB() {
      this.initCbData()
      this.cbLoading = true

      await this.clearDB()
      let res = await this.$http.getSyncToken({ userId: this.userItem.id })

      // dbName: `${this.userInfo.uid}-boox-message`,
      //     channels: `${this.userInfo.uid}-MESSAGE`
      await this.updateSyncChannels([`${this.userItem.uid}-MESSAGE`])

      this.$cookie.set(res.data.cookie_name, res.data.session_id)
      this.pullNotes(this.userItem.uid)
    },

    async updateSyncChannels(rootChannel) {
      const channls = {
        action: 'add',
        userId: this.userItem.id,
        channels: rootChannel
      }
      return this.$http.updateSyncChannels(channls)
    },
    async clearDB() {
      return new Promise(async (resolve, reject) => {
        try {
          let r = await indexedDB.databases()
          for (let i of r) {
            indexedDB.deleteDatabase(i.name)
          }
          // this.$cookie.remove("SyncGatewaySession");
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    },

    async pullNotes(uid) {
      let opts = {
        dbName: `${uid}-boox-message`,
        channels: `${uid}-MESSAGE`
      }
      await syncUtils.pull(opts)
      let res = await syncUtils.getChannel(opts)
      let data = res.filter((item) => item.msgType === 2)
      // console.log(data, '----------')
      // let folder = res.filter((item) => item.association && item.type === 0)
      // let data = res.filter((item) => item.association && item.type === 1)

      // let arr = []
      // for (let item of data) {
      //   arr = [...arr, `${this.userItem.uid}-${item.uniqueId}`]
      //   let parent = folder.find((ele) => ele.uniqueId === item.parentUniqueId)
      //   item.parentTitle = parent ? parent.name : ''
      //   item.shapeLoading = false
      // }
      // await this.updateSyncChannels(arr)
      this.originData = data
      this.filterDataForDir()
      console.log('CB allData============:', res)
      console.log('CB Data============:', this.cbData)
      this.cbLoading = false
    },

    filterDataForDir() {
      if (this.filterType && this.filterType.length) {
        this.cbData = this.originData.filter((item) =>
          this.filterType.includes(item.contentType)
        )
      } else {
        this.cbData = this.originData
      }
      this.cuttingCbData()
    },

    async tableHandle(obj) {
      if (obj.type === 'checkDetails') {
        this.showPushFileDetails = true
        this.checkNotesCbDetails(obj.data.row)
      } else if (obj.type === 'checkShape') {
        obj.data.row.shapeLoading = true
        this.pullNotesShape(obj.data.row)
      }
    },

    async checkNotesCbDetails(item) {
      try {
        this.cbDetailsLoading = true
        let data = item
        if (!item.shapeList || !item.shapeList.length) {
          data = await this.pullNotesShape(item)
        }
        let res = await this.getUserOssData()
        data.ossData = res
        this.currentCbItem = data
        this.currentCbPageId = this.currentCbItem.pageNameList.pageNameList[0]
        console.log('currentCbItem', this.currentCbItem)
        this.cbDetailsLoading = false
      } catch (error) {
        console.log(error)
        this.cbDetailsLoading = false
      }
    },

    async getUserOssData() {
      try {
        let params = {
          userId: this.userItem.id,
          dir: 'point'
        }
        let res = await this.$http.checkOssInfo(params)
        return res.data
      } catch (error) {
        throw new Error(error)
      }
    },

    async pullNotesShape(item) {
      try {
        let opts = {
          dbName: `${item.uniqueId}_shape`,
          channels: `${this.userItem.uid}-${item.uniqueId}`
        }
        await syncUtils.pull(opts)

        let res = await syncUtils.getChannel(opts)
        let arr = res.filter((val) => val.updatedAt)
        this.$set(item, 'shapeList', arr)
        this.$set(item, 'shapeCount', arr.length)
        item.shapeLoading = false
        return item
      } catch (error) {
        item.shapeLoading = false
        throw new Error(error)
      }
    },
    cbHandle() {
      this.filterDataForDir()
      this.clearCbSearch()
      this.$refs.cbSearch ? this.$refs.cbSearch.clearValue() : null
    },

    filterEvn(data) {
      let { key, obj } = data
      if (key === 'contentType') {
        this.initCbData()
        this.filterType = obj[key] && obj[key].length ? obj[key] : []
        this.filterDataForDir()
      }
    },

    cbPageNum(page) {
      this.cbPage = page
      if (this.sortData.length) {
        this.cuttingCbSortData()
      } else {
        this.cbSearch ? this.cuttingCbSearchData() : this.cuttingCbData()
      }
    },
    closeCbDialog() {
      this.cbLoading = false
      this.$emit('close')
    },
    cbSearchEvn(val) {
      this.cbSearch = val
      this.cbPage = 1
      if (val) {
        this.searchData = this.cbData.filter((item) =>
          this.cbSearchType === 'uniqueId'
            ? item.uniqueId && item.uniqueId.indexOf(val) !== -1
            : item.parentTitle && item.parentTitle.indexOf(val) !== -1
        )
        this.cuttingCbSearchData()
      } else {
        this.clearCbSearch()
      }
    },
    clearCbSearch() {
      this.cbSearch = ''
      this.cbPage = 1
      this.cuttingCbData()
    },

    cuttingCbData() {
      this.cbDataLength = this.cbData.length
      this.limitData = this.cbData.slice(
        (this.cbPage - 1) * this.cbLimit,
        this.cbPage * this.cbLimit
      )
    },

    cuttingCbSearchData() {
      this.limitData = this.searchData.slice(
        (this.cbPage - 1) * this.cbLimit,
        this.cbPage * this.cbLimit
      )
      this.cbDataLength = this.searchData.length
    },

    cuttingCbSortData() {
      this.limitData = this.sortData.slice(
        (this.cbPage - 1) * this.cbLimit,
        this.cbPage * this.cbLimit
      )
    },

    cbTableSortOrder({ prop, order }) {
      if (this.cbSearch) {
        this.sortData = JSON.parse(JSON.stringify(this.searchData))
      } else {
        this.sortData = JSON.parse(JSON.stringify(this.cbData))
      }

      if (order) {
        this.sortData = this.$_.orderBy(
          this.sortData,
          prop,
          order === 'ascending' ? 'asc' : 'desc'
        )
        this.cuttingCbSortData()
      } else {
        this.sortData = []
        this.cbSearch ? this.cuttingCbSearchData() : this.cuttingCbData()
      }
    }
  }
}
</script>

<style lang="scss">
.user-cbDialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-cbDialog-header-right {
    display: flex;
    align-items: center;
    > .el-select {
      width: 100px;
    }
    > button {
      margin-top: 0;
      margin-left: 20px;
    }
  }
}
.user-cbDialog-main {
  margin-top: 20px;
}
.cbDetailsDialog-item + .cbDetailsDialog-item {
  margin-top: 20px;
}
.cbDetailsDialog-item {
  display: flex;
  align-items: center;
}
</style>
